import { HeaderLogoResponse } from "@/Interface/Api/HeaderLogo";
import {
  IBaseData,
  IResponseBody,
} from "../../../../Interface/Api/BaseResponseInterface";
import { HomeSlice } from "../Home/HomeSlice";

const HeaderLogoTags = HomeSlice.enhanceEndpoints({
  addTagTypes: ["header_logo_read"],
});

const HeaderLogoSlice = HeaderLogoTags.injectEndpoints({
  endpoints: (builder) => ({
    getHeaderLogo: builder.query<IBaseData<HeaderLogoResponse[]>, void>({
      query: () => ({
        url: `header-images`,
        method: "GET",
      }),
      providesTags: ["header_logo_read"],
      transformResponse: (
        response: IResponseBody<IBaseData<HeaderLogoResponse[]>>
      ) => response.data as IBaseData<HeaderLogoResponse[]>,
    }),
  }),
});

export const { useGetHeaderLogoQuery } = HeaderLogoSlice;
